import _notification from "antd/es/notification";
var _excluded = ["icon", "className", "top"],
  _excluded2 = ["icon", "className", "top"],
  _excluded3 = ["icon", "className", "top"],
  _excluded4 = ["icon", "className", "top"],
  _excluded5 = ["icon", "className", "top"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import SLSymbolIcon from '../OneSymbolIcon';
import cs from 'classnames';
import './index.less';
var OneNotification = _objectSpread(_objectSpread({}, _notification), {}, {
  success: function success(_ref) {
    var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
        className: "one-notification-icon",
        icon: "icon-iconCheckCircle"
      }) : _ref$icon,
      className = _ref.className,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? 80 : _ref$top,
      rest = _objectWithoutProperties(_ref, _excluded);
    _notification.success(_objectSpread({
      icon: icon,
      className: cs(className, 'one-notification', 'one-notification-success'),
      top: top
    }, rest));
  },
  error: function error(_ref2) {
    var _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
        className: "one-notification-icon",
        icon: "icon-iconCloseCircle"
      }) : _ref2$icon,
      className = _ref2.className,
      _ref2$top = _ref2.top,
      top = _ref2$top === void 0 ? 80 : _ref2$top,
      rest = _objectWithoutProperties(_ref2, _excluded2);
    _notification.error(_objectSpread({
      icon: icon,
      className: cs(className, 'one-notification', 'one-notification-error'),
      top: top
    }, rest));
  },
  info: function info(_ref3) {
    var _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
        className: "one-notification-icon",
        icon: "icon-iconinfo-circle"
      }) : _ref3$icon,
      className = _ref3.className,
      _ref3$top = _ref3.top,
      top = _ref3$top === void 0 ? 80 : _ref3$top,
      rest = _objectWithoutProperties(_ref3, _excluded3);
    _notification.info(_objectSpread({
      icon: icon,
      className: cs(className, 'one-notification', 'one-notification-info'),
      top: top
    }, rest));
  },
  warn: function warn(_ref4) {
    var _ref4$icon = _ref4.icon,
      icon = _ref4$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
        className: "one-notification-icon",
        icon: "icon-iconinfo-circle"
      }) : _ref4$icon,
      className = _ref4.className,
      _ref4$top = _ref4.top,
      top = _ref4$top === void 0 ? 80 : _ref4$top,
      rest = _objectWithoutProperties(_ref4, _excluded4);
    _notification.warn(_objectSpread({
      icon: icon,
      className: cs(className, 'one-notification', 'one-notification-warn'),
      top: top
    }, rest));
  },
  warning: function warning(_ref5) {
    var _ref5$icon = _ref5.icon,
      icon = _ref5$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
        className: "one-notification-icon",
        icon: "icon-iconinfo-circle"
      }) : _ref5$icon,
      className = _ref5.className,
      _ref5$top = _ref5.top,
      top = _ref5$top === void 0 ? 80 : _ref5$top,
      rest = _objectWithoutProperties(_ref5, _excluded5);
    _notification.warning(_objectSpread({
      icon: icon,
      className: cs(className, 'one-notification', 'one-notification-warn'),
      top: top
    }, rest));
  }
});
export default OneNotification;